import { render } from "./GeneralDynamicParametres.vue?vue&type=template&id=0415caef&scoped=true"
import script from "./GeneralDynamicParametres.vue?vue&type=script&lang=js"
export * from "./GeneralDynamicParametres.vue?vue&type=script&lang=js"

import "./GeneralDynamicParametres.vue?vue&type=style&index=0&id=0415caef&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0415caef"]])

export default __exports__